import type { CSSProperties, ReactNode } from 'react';
import React from 'react';

type CarouselItemAriaLabel = `slide ${number} of ${number}`;

export const CarouselItem = ({
  ariaLabel,
  children,
  style,
}: {
  ariaLabel: CarouselItemAriaLabel;
  children: ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <li aria-label={ariaLabel} aria-roledescription="slide" role="group" style={style}>
      {children}
    </li>
  );
};
